// src/Es.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Es_default = createIcon({
  displayName: "Es",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { fill: "#FBB43A", d: "M1 1h48v32H1z" }),
    /* @__PURE__ */ jsx("path", { fill: "#FF1A26", d: "M1 1h48v8H1zM1 25h48v8H1z" }),
    /* @__PURE__ */ jsx("path", { fill: "#DEE5ED", fillRule: "evenodd", d: "M8 13.5V23h.5v1h-3v-1H6v-9.5h2Z", clipRule: "evenodd" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "7", cy: "13.5", fill: "#FF1A26", rx: "1", ry: ".5" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#DEE5ED",
        fillRule: "evenodd",
        d: "M8.9585 13.4107h10.0833v7.1191c0 2.4573-2.2572 3.5595-5.0416 3.5595-2.7845 0-5.0417-1.1022-5.0417-3.5595v-7.1191Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#FF1A26", d: "M9.417 13.8214h4.5833v4.1071H9.417z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FBB43A",
        d: "M9.417 17.9286h4.5833v2.6369c0 1.2656-1.026 2.2917-2.2916 2.2917-1.2657 0-2.2917-1.0261-2.2917-2.2917v-2.6369Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FF1A26",
        d: "M14 17.9286h4.5833v2.6369c0 1.2656-1.026 2.2917-2.2916 2.2917-1.2657 0-2.2917-1.0261-2.2917-2.2917v-2.6369Z"
      }
    ),
    /* @__PURE__ */ jsx("ellipse", { cx: "16.292", cy: "15.875", fill: "#FF1A26", rx: "1.375", ry: "1.6429" }),
    /* @__PURE__ */ jsx("path", { fill: "#DEE5ED", fillRule: "evenodd", d: "M22 13.5V23h.5v1h-3v-1h.5v-9.5h2Z", clipRule: "evenodd" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "21", cy: "13.5", fill: "#FF1A26", rx: "1", ry: ".5" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "14", cy: "11.5", fill: "#FF1A26", rx: "4", ry: "1.5" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F1F4F8"
      }
    )
  ] })
});

export {
  Es_default
};
